import { TabId } from "@blueprintjs/core";
import { IMPDTreeNode } from "src/mpd-library";
import {
  changedTabs,
  closeRightPanel,
  composeRowClicked,
  handleCollapse,
  handleExpand,
  hideCompose,
  rowClicked,
  searchChanged,
  showCompose,
  toggleRightPanel,
  toggleSearchBar
} from "./alerts-list-api";

export const onChangedTabs = (tabId: TabId, listItemType: any) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { data } = alerts;
    const { list } = data;
    changedTabs({ dispatch, list, listItemType, tabId });
  };
};

export const onRowClicked = (nodeData: IMPDTreeNode, history: any) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { data, tabId } = alerts;
    if (tabId === "drafts") {
      composeRowClicked({
        dispatch,
        data,
        tabId,
        history,
        nodeData
      });
    } else {
      rowClicked({
        dispatch,
        data,
        tabId,
        history,
        nodeData
      });
    }
  };
};

export const onHandleCollapse = (nodeData: IMPDTreeNode) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { list, warningActive } = alerts;
    handleCollapse({ nodeData, dispatch, list, warningActive });
  };
};

export const onHandleExpand = (nodeData: IMPDTreeNode) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { list } = alerts;
    handleExpand({ nodeData, dispatch, list });
  };
};

export const onHideCompose = (history: any) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { list, nodeData, tabId } = alerts;
    hideCompose({
      nodeData,
      list,
      dispatch,
      history, 
      tabId
    });
  };
};

export const onShowCompose = (history: any) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { list, nodeData } = alerts;
    showCompose({
      nodeData,
      list,
      dispatch,
      history
    });
  };
};

export const onToggleRightPanel = () => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { rightPanelExpanded } = alerts;
    toggleRightPanel({ dispatch, rightPanelExpanded });
  };
};

export const onCloseRightPanel = (history: any) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { nodeData, data, tabId } = alerts;
    closeRightPanel({ dispatch, nodeData, data, tabId, history });
  };
};

export const onSearchChanged = (value?: string) => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { data, tabId } = alerts;
    const { list } = data;
    searchChanged({ dispatch, list, tabId, value });
  };
};

export const onToggleSearchBar = () => {
  return (dispatch: any, getState: any) => {
    const alerts = getState().alerts;
    const { searchBarActive, data, tabId } = alerts;
    const { list } = data;
    toggleSearchBar({ dispatch, searchBarActive, list, tabId });
  };
};



// WEBPACK FOOTER //
// ./src/actions/alerts/alerts-list.tsx